export const GET_RECIPIENT_CONNECTION_GRID =
  '/api/recipient-connection/get-recipient-connection-grid';
export const GET_RECIPIENT_CONNECTION_DETAIL =
  '/api/recipient-connection/get-recipient-connection-detail';
export const SAVE_RECIPIENT_CONNECTION =
  '/api/recipient-connection/save-recipient-connection';
export const DELETE_RECIPIENT_CONNECTION =
  '/api/recipient-connection/delete-recipient-connection';
export const CHECK_RECIPIENT_PUBLISH_REQUIREMENT =
  'api/recipient-connection/check-recipient-publish-requirement';
